import { getCurrentUser } from '@/api/home/home.js'
import axios from '@/api/utils/axios'
import { normalizeEcoUserProfile } from '../adapters/index.js'

let currentUserInFlight = null
let currentUserCache = null
let currentUserCacheAt = 0
const CURRENT_USER_CACHE_TTL_MS = 5000

/** 认证提交/审核后需拉取最新用户与认证状态 */
export function invalidateSchemeEcoCurrentUserCache() {
  currentUserCache = null
  currentUserCacheAt = 0
  currentUserInFlight = null
}

export async function fetchSchemeEcoCurrentUser(raw = false, options = {}) {
  if (options.forceRefresh) {
    invalidateSchemeEcoCurrentUserCache()
  }
  const now = Date.now()
  if (currentUserCache && now - currentUserCacheAt < CURRENT_USER_CACHE_TTL_MS) {
    return raw ? currentUserCache.raw : currentUserCache.normalized
  }

  if (!currentUserInFlight) {
    currentUserInFlight = (async () => {
      const res = await getCurrentUser()
      if (res?.code !== '00000') return null
      const model = res.model || null
      currentUserCache = {
        raw: model,
        normalized: normalizeEcoUserProfile(model)
      }
      currentUserCacheAt = Date.now()
      return currentUserCache
    })().finally(() => {
      currentUserInFlight = null
    })
  }

  const user = await currentUserInFlight
  if (!user) return null
  return raw ? user.raw : user.normalized
}

function pickUserIdFromRow(row) {
  if (!row) return ''
  return (
    row.id ||
    row.userId ||
    row.systemUserId ||
    row.memberId ||
    row.creatorId ||
    ''
  )
}

function matchPhone(phoneA, phoneB) {
  const a = String(phoneA || '').replace(/\D/g, '')
  const b = String(phoneB || '').replace(/\D/g, '')
  if (!a || !b) return false
  return a === b
}

export async function fetchSchemeUserByPhone(phone) {
  const mobilePhone = String(phone || '').trim()
  if (!mobilePhone) return null

  try {
    const res = await axios.get(`/longstron/system/users/username/${encodeURIComponent(mobilePhone)}`)
    if (!res || res.code !== '00000') return null
    const model = res.model || null
    if (!model) return null
    const resolvedPhone = model.mobilePhone || model.phone || model.linkPhone || model.username || mobilePhone
    if (!matchPhone(resolvedPhone, mobilePhone)) return null
    const userId = pickUserIdFromRow(model)
    if (!userId) return null
    return {
      userId: String(userId),
      name: model.name || model.realName || model.username || '',
      mobilePhone: resolvedPhone,
      raw: model
    }
  } catch (e) {
    return null
  }
}
